import { Routes } from '@angular/router'
import { SearchPageComponent } from './search-page.component'
import { SearchPageRedirectorComponent } from './search-page-redirector.component'
import { searchPageGuard } from 'src/app/core/guards/search-page.guard'
import { SearchRoutePaths } from 'src/app/core/data/search-route-paths.data'

export const SEARCH_ROUTES: Routes = [
  {
    path: '',
    component: SearchPageComponent,
    canActivate: [searchPageGuard],
  },
  {
    path: SearchRoutePaths.Category,
    component: SearchPageRedirectorComponent,
    canActivate: [searchPageGuard],
  },
  {
    path: SearchRoutePaths.Subcategory,
    component: SearchPageRedirectorComponent,
    canActivate: [searchPageGuard],
  },
  {
    path: SearchRoutePaths.Make,
    component: SearchPageRedirectorComponent,
    canActivate: [searchPageGuard],
  },
  {
    path: SearchRoutePaths.Model,
    component: SearchPageRedirectorComponent,
    canActivate: [searchPageGuard],
  },
  {
    path: SearchRoutePaths.Country,
    component: SearchPageRedirectorComponent,
    canActivate: [searchPageGuard],
  },
  {
    path: SearchRoutePaths.State,
    component: SearchPageRedirectorComponent,
    canActivate: [searchPageGuard],
  },
  {
    path: SearchRoutePaths.City,
    component: SearchPageRedirectorComponent,
    canActivate: [searchPageGuard],
  },
]

